'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');
require('../../utils/ref/refType.js');
var withIntlAriaAttrs = require('../../withIntlAriaAttrs-d3af74a8.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

/* stylelint-disable no-descending-specificity */
var colorMap = {
  "default": styled.css(["background-color:", ";color:", ";&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){color:", ";}"], styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('primary', 'default'), styles_themeUtils.nuDSColor('primary', 'light')),
  primary: styled.css(["background-color:", ";color:", ";&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){background-color:", ";}"], styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('primary', 'light')),
  secondary: styled.css(["background-color:", ";color:", ";&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){background-color:", ";}"], styles_themeUtils.nuDSColor('white', 'dark'), styles_themeUtils.nuDSColor('black', 'defaultT70'), styles_themeUtils.nuDSColor('white', 'dark'))
};
var outlineColorMap = {
  primary: styled.css(["border-color:", ";color:", ";background-color:transparent;&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){background-color:", ";}&:disabled{border-color:", ";background-color:transparent;}"], styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('primary', 'defaultL10'), styles_themeUtils.nuDSColor('black', 'defaultT20'))
};
var textColorMap = {
  primary: styled.css(["", ""], outlineColorMap.primary),
  "default": styled.css(["background-color:transparent;color:", ";&:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){color:", ";}&:disabled{background-color:transparent;color:", ";}"], styles_themeUtils.nuDSColor('white', 'dark'), styles_themeUtils.nuDSColor('primary', 'light'), styles_themeUtils.nuDSColor('white', 'defaultT70'))
};

var varyStyles = function varyStyles(_ref) {
  var color = _ref.color,
      variant = _ref.variant;
  var variantMap = {
    text: styled.css(["", ""], textColorMap[color]),
    contained: styled.css(["", " box-shadow:0px 2px 2px rgba(0,0,0,0.12),0px 0px 2px rgba(0,0,0,0.14);"], colorMap[color])
  };
  return variantMap[variant];
};

var fullWidthStyles = function fullWidthStyles(_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth && styled.css(["width:100%;"]);
};

var Button = styled__default['default'].button.withConfig({
  displayName: "Button",
  componentId: "sc-1140nyd-0"
})(["appearance:none;border-radius:2px;border:none;outline:none;cursor:pointer;text-align:center;padding:19px 32px;user-select:none;min-height:56px;transition:ease-in-out 200ms;transition-property:background,color;white-space:nowrap;display:inline-flex;justify-content:center;align-items:center;&:disabled{background-color:", ";cursor:not-allowed;box-shadow:none;color:", ";}", ";", ";"], styles_themeUtils.nuDSColor('white', 'dark'), styles_themeUtils.nuDSColor('black', 'defaultT20'), varyStyles, fullWidthStyles);
Button.displayName = 'Button';
Button.propTypes = {
  color: index.propTypes.oneOf(['default', 'primary']).isRequired,
  fullWidth: index.propTypes.bool.isRequired
};

var BaseButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default['default'].createElement(Button, _extends._extends_1({}, props, {
    ref: ref
  }));
});
BaseButton.defaultProps = {
  color: 'default',
  fullWidth: false
};
BaseButton.propTypes = {
  color: index.propTypes.oneOf(['default', 'primary']),
  fullWidth: index.propTypes.bool
};

function renderTypographyComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = arguments.length > 1 ? arguments[1] : undefined;
  return /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], _extends._extends_1({
    color: "inherit"
  }, props), children);
}

function DeprecatedButton(props) {
  var children = props.children,
      href = props.href,
      activeClassName = props.activeClassName,
      buttonRef = props.buttonRef,
      locale = props.locale,
      forceRefresh = props.forceRefresh,
      intlKey = props.intlKey,
      typographyVariant = props.typographyVariant,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["children", "href", "activeClassName", "buttonRef", "locale", "forceRefresh", "intlKey", "typographyVariant"]);

  var as = href ? 'a' : 'button';
  var componentChildren = renderTypographyComponent({
    intlKey: intlKey,
    variant: typographyVariant
  }, children);
  return /*#__PURE__*/React__default['default'].createElement(BaseButton, _extends._extends_1({}, rest, as === 'a' && {
    href: href
  }, {
    as: as,
    ref: buttonRef
  }), componentChildren);
}

DeprecatedButton.defaultProps = {
  color: 'default',
  variant: 'text',
  disabled: false,
  fullWidth: false,
  onClick: undefined,
  type: 'button',
  className: undefined,
  activeClassName: null,
  href: '',
  intlKey: '',
  children: undefined,
  buttonRef: undefined,
  locale: null,
  forceRefresh: false,
  typographyVariant: 'action'
};
DeprecatedButton.propTypes = {
  activeClassName: index.propTypes.string,
  buttonRef: index.propTypes.shape({
    current: index.propTypes.oneOfType([index.propTypes.element, index.propTypes.object])
  }),
  children: index.propTypes.node,
  className: index.propTypes.string,
  color: index.propTypes.oneOf(['default', 'primary', 'secondary']),
  disabled: index.propTypes.bool,
  forceRefresh: index.propTypes.bool,
  fullWidth: index.propTypes.bool,
  href: index.propTypes.string,
  intlKey: index.propTypes.string,
  locale: index.propTypes.string,
  onClick: index.propTypes.func,
  type: index.propTypes.string,
  typographyVariant: components_Typography_Typography.typographyVariantsPropType,
  variant: index.propTypes.oneOf(['text', 'contained'])
};
var Button$1 = withIntlAriaAttrs.withIntlAriaAttrs(DeprecatedButton);

exports.default = Button$1;
//# sourceMappingURL=DeprecatedButton.js.map
